import React, { useContext } from "react";
import CardApplicationAPI from "../../api/commercial/card-application";
import { ApplicationFlows } from "../../route/application/authenticated/application-flow/types";
import { ApplicationFlowSteps } from "../../route/application/authenticated/application-flow/types";
import { ErrorContext } from "../../route/error/provider";
import { CardholderModel } from "../cardholder-basic-information/cardholder-form/types";
import CardholderBasicMapper from "../cardholder-basic-information/mapper";
import Summary from "./index";
import { LanguageContext } from "../../context/languageContext";
import { CardApplicationDocument } from "../../api/commercial/generated-types";
import { ProductRefType } from "../../context/product-context/types";

export default function SummaryAdapter({
  flowType,
  cardApplication,
  triggerReload,
  setStep,
}: {
  flowType: ApplicationFlows;
  cardApplication: CardApplicationDocument;
  triggerReload: () => void;
  setStep: (step: ApplicationFlowSteps) => void;
}): React.JSX.Element {
  const { setError } = useContext(ErrorContext);
  const basicApplicationRef = cardApplication.basicAccountApplicationRef;
  const cardApplicationRef = cardApplication.applicationRef;
  const selectedProduct = cardApplication.productRef as ProductRefType;

  const company = cardApplication.company;

  const { language } = useContext(LanguageContext);

  const cardholder: CardholderModel =
    CardholderBasicMapper.mapCardholderDocumentToPageModel(
      cardApplication,
      language,
    );

  return (
    <Summary
      flowType={flowType}
      context={{
        cardholder,
        companyName: company.name,
        selectedProduct,
        basicApplicationRef,
        cardApplicationRef,
      }}
      previous={() => setStep(ApplicationFlowSteps.CHOOSE_SIGNATORIES)}
      next={async () => {
        try {
          if (flowType === ApplicationFlows.ADDITIONAL_CA) {
            await CardApplicationAPI.readyForSigningAdditionalCardApplication(
              basicApplicationRef,
              cardApplicationRef,
            );
          } else {
            await CardApplicationAPI.readyForSigningFirstCardApplication(
              basicApplicationRef,
              cardApplicationRef,
            );
          }
        } catch (e) {
          setError(e);
        }
        triggerReload();
      }}
    />
  );
}
